import { REDIRECT_AFTER_AUTH_PARAM } from '@components/App/Auth/VerifyEmail/constants'
import type { AppState } from '@store/types'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate, useSearchParams } from 'react-router-dom'

export const useRedirectAfterAuth = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const authenticated = useSelector<AppState, boolean>((state) =>
    Boolean(state.auth.authenticated && state.auth.setupCompleted)
  )

  useEffect(() => {
    const rawRedirect = searchParams.get(REDIRECT_AFTER_AUTH_PARAM)
    const redirect = rawRedirect ? decodeURIComponent(rawRedirect) : null

    if (authenticated && redirect) {
      if (redirect.startsWith('/')) {
        navigate(redirect)
      }
    }
  }, [authenticated, navigate, searchParams])
}
